<template>
<div v-loading="exportLoading" element-loading-text="正在回库">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-button type="primary" @click="exportTable()">批量回库</el-button>
                <el-radio-group v-model="backType" @change="agreeChange">
                    <el-radio  label="1">卡号</el-radio>
                    <el-radio  label="2">ICCID</el-radio>
                    <el-radio  label="3">IMSI</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </el-col>
    <el-input type="textarea" :rows="20" :placeholder="placeholder" v-model="textarea" class="textexport">
    </el-input>
</div>
</template>

<script>
import {
    bathCardBack
} from '../../api/api'
export default {
    data() {
        return {
            isUpload: true,
            url: '',
            textarea: '',
            exportLoading: false,
            backType : "1",
            placeholder : "请粘贴要导出的卡号列表(每一条一行)"
        }
    },
    methods: {
        exportTable() {

            if (this.textarea.trim() == "") {
                this.$message({
                    message: '卡信息不能为空',
                    type: 'error'
                });
            } else {
                let para = {
                    cardinfo: this.textarea.trim(),
                    backType : this.backType
                }
                this.exportLoading = true;
                bathCardBack(para).then((res) => {
                            if(res.code==0){
                                this.url=res.data;
                                this.isUpload=true;
                                this.exportLoading=false;
                                this.textarea=res.msg;
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                                this.exportLoading=false;
                                this.isUpload=false;
                            }
                        });
            }
        },
        agreeChange:function(val){
          if("1" == val){
              this.placeholder = "请粘贴要导出的卡号列表(每一条一行)";
          }
          if("2" == val){
              this.placeholder = "请粘贴要导出的ICCID列表(每一条一行)";
          }
           if("3" == val){
              this.placeholder = "请粘贴要导出的IMSI列表(每一条一行)";
          }
        }

    }

}
</script>  

<style>
.textexport {
    margin-top: 10px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// batch_back.vue?f7e64888